import {
  GET_COMPANIES,
  SHOW_TOAST,
  FB_URL
} from './types'
import firebase from '../firebase'
import axios from 'axios'

export const getCompanies = params => {
  return (dispatch, getState) => {
    //
    firebase.database
      .ref('companies')
      .limitToLast(params.minData)
      .on('value', function (data) {
        if (data.val()) {
          dispatch({
            type: GET_COMPANIES,
            companies: data.val()
          })
        } else {
          dispatch({
            type: GET_COMPANIES,
            companies: {}
          })
        }
      })
  }
}

export const updateNewCompany = (params, edit) => {
  return async (dispatch, getState) => {
    const dbref = 'companies'
    const dbref2 = 'active-companies'
    const updates = {}

    try {
      if (edit) {
        if (!params.companyID) throw new Error('Missing companyID on edit')

        // Per-field writes: the component strips dateRegistered/stringDateRegistered
        // on edit, so writing the whole object would delete them
        const { companyID, ...fields } = params
        Object.keys(fields).forEach(key => {
          updates[`/${dbref}/${companyID}/${key}`] = fields[key]
        })
      } else {
        // push().key is generated locally, no write happens, so rules don't block it
        params.companyID = firebase.database.ref(dbref).push().key
        updates[`/${dbref}/${params.companyID}`] = params
      }

      updates[`/${dbref2}/${params.companyID}/companyID`] = params.companyID
      updates[`/${dbref2}/${params.companyID}/companyName`] = params.companyName

      const res = await axios.post(`${FB_URL}/m115-freshcard`, {
        params: { updates }
      })

      if (res.data && res.data.success === true) {
        dispatch({
          type: SHOW_TOAST,
          open: true,
          variant: 'success',
          message: edit ? 'Company updated successfully!' : 'Company posted successfully!'
        })
      } else {
        throw new Error((res.data && res.data.message) || 'Update failed')
      }
    } catch (err) {
      console.error('updateNewCompany error', err)
      dispatch({
        type: SHOW_TOAST,
        open: true,
        variant: 'error',
        message: 'Error response: ' + err.message
      })
    }
  }
}
